import { render, staticRenderFns } from "./DistrubutiveUser.vue?vue&type=template&id=935ebe42&scoped=true&"
import script from "./DistrubutiveUser.vue?vue&type=script&lang=js&"
export * from "./DistrubutiveUser.vue?vue&type=script&lang=js&"
import style0 from "./DistrubutiveUser.vue?vue&type=style&index=0&id=935ebe42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935ebe42",
  null
  
)

export default component.exports